import React from 'react';
import { Pagination } from 'react-bootstrap';

const AppPagination = ({ page, totalPages, onPageChange }) => {
    const items = [];

    const maxVisible = 5; // kitne pages beech me dikhane hain

    let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);

    // adjust start if end reached
    if (endPage - startPage < maxVisible - 1) {
        startPage = Math.max(1, endPage - maxVisible + 1);
    }

    // First page
    if (startPage > 1) {
        items.push(
            <Pagination.Item key={1} onClick={() => onPageChange(1)}>
                1
            </Pagination.Item>
        );

        if (startPage > 2) {
            items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
        }
    }

    // Middle pages
    for (let number = startPage; number <= endPage; number++) {
        items.push(
            <Pagination.Item
                key={number}
                active={number === page}
                onClick={() => onPageChange(number)}
            >
                {number}
            </Pagination.Item>
        );
    }

    // Last page
    if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
            items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
        }

        items.push(
            <Pagination.Item
                key={totalPages}
                onClick={() => onPageChange(totalPages)}
            >
                {totalPages}
            </Pagination.Item>
        );
    }

    return (
        <Pagination className="mb-0">
            <Pagination.First onClick={() => onPageChange(1)} disabled={page === 1} />
            <Pagination.Prev onClick={() => onPageChange(page - 1)} disabled={page === 1} />
            {items}
            <Pagination.Next onClick={() => onPageChange(page + 1)} disabled={page === totalPages} />
            <Pagination.Last onClick={() => onPageChange(totalPages)} disabled={page === totalPages} />
        </Pagination>
    );
};

export default AppPagination;